import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "requirement-title iodine-padding-top-lg" }, "Requirement", -1)

import {SuggestedDrgRequirementDataModel} from 'components/resources/SuggestedDrgRequirementData.model';
  import CodesList from 'components/resources/CodesList.vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedDrgRequirement',
  props: {
    suggestedDrgRequirementDataModel: {}
  },
  setup(__props: any) {

  const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.suggestedDrgRequirementDataModel, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "suggested-drg-requirement",
      key: index
    }, [
      _hoisted_1,
      _createElementVNode("div", null, _toDisplayString(item.description), 1),
      _createVNode(CodesList, {
        "codes-list": item.codelist
      }, null, 8, ["codes-list"])
    ]))
  }), 128))
}
}

})